import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Container } from '../components/Container';
interface FeatureSpotlightProps {
  eyebrow: string;
  title: React.ReactNode;
  description: string;
  bullets?: string[];
  outcome?: string;
  visual: React.ReactNode;
  reverse?: boolean;
  layout?: 'split' | 'stacked';
}
export function FeatureSpotlight({
  eyebrow,
  title,
  description,
  bullets,
  outcome,
  visual,
  reverse,
  layout = 'split'
}: FeatureSpotlightProps) {
  if (layout === 'stacked') {
    return <section className="py-12 sm:py-24" data-id="element-750">
        <Container data-id="element-751">
          <div className="mx-auto max-w-3xl text-left sm:text-center" data-id="element-752">
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-accent" data-id="element-753">
              {eyebrow}
            </div>
            <h3 className="mt-4 text-balance font-serif-display text-[2.5rem] leading-[1.02] tracking-tight text-white sm:text-5xl sm:leading-[1.05]" data-id="element-754">
              {title}
            </h3>
            <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-zinc-400 sm:mx-auto sm:mt-5 sm:text-base" data-id="element-755">
              {description}
            </p>
          </div>

          <div className="relative mx-auto mt-12 max-w-4xl" data-id="element-756">
            <div className="absolute -inset-x-10 -inset-y-6 rounded-[2rem] bg-accent/5 blur-3xl" aria-hidden data-id="element-757" />
            <div className="relative" data-id="element-758">{visual}</div>
          </div>

          {bullets && <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="mx-auto mt-10 max-w-3xl" data-id="element-759">
              <ul className="grid gap-3 sm:grid-cols-3" data-id="element-760">
                {bullets.map(b => <li key={b} className="flex items-start gap-3 rounded-xl border border-white/5 bg-zinc-900/40 p-4 text-sm text-zinc-300" data-id="element-761">
                    <span className="mt-0.5 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full bg-accent/15" data-id="element-762">
                      <CheckIcon className="h-2.5 w-2.5 text-accent" strokeWidth={3} data-id="element-763" />
                    </span>
                    {b}
                  </li>)}
              </ul>
            </motion.div>}
        </Container>
      </section>;
  }
  return <section className="py-12 sm:py-24" data-id="element-764">
      <Container data-id="element-765">
        <div className="grid items-center gap-10 sm:gap-12 lg:grid-cols-[5fr_6fr] lg:gap-14" data-id="element-766">
          <div className={reverse ? 'lg:order-2' : ''} data-id="element-767">
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-accent" data-id="element-768">
              {eyebrow}
            </div>
            <h3 className="mt-4 text-balance font-serif-display text-[2.5rem] leading-[1.02] tracking-tight text-white sm:text-5xl sm:leading-[1.05]" data-id="element-769">
              {title}
            </h3>
            <p className="mt-4 max-w-lg text-[15px] leading-relaxed text-zinc-400 sm:mt-5 sm:text-base" data-id="element-770">
              {description}
            </p>

            {bullets && <ul className="mt-7 space-y-3" data-id="element-771">
                {bullets.map(b => <li key={b} className="flex items-start gap-3 text-sm text-zinc-300" data-id="element-772">
                    <span className="mt-0.5 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full bg-accent/15" data-id="element-773">
                      <CheckIcon className="h-2.5 w-2.5 text-accent" strokeWidth={3} data-id="element-774" />
                    </span>
                    {b}
                  </li>)}
              </ul>}
          </div>

          <div className={reverse ? 'lg:order-1' : ''} data-id="element-775">{visual}</div>
        </div>
      </Container>
    </section>;
}